(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {
	
	// var
	var $markers = $el.find('.marker');
	
	
	// vars
	var args = {
		zoom		: 16,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
		streetViewControl: false,
        disableDefaultUI: true,
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	center_map( map );
	
	
	// return
	return map;
	
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.acf-map').each(function(){

		// create map
		map = new_map( $(this) );

	});

});

})(jQuery);
$ = jQuery;
//Preloader
Loader();
//Sections and links
Section_and_Anchor();
//Image attr on hover
ImgHover();
//Mobile header
MobileHeader();
//Sticky header
StickyHeader();
//Phones accordion
PhonesHeader();
//Form validation
FormValidation();
//Remove br tag
remove_footer_BR();
//FormRedirect();

//Form validation
function FormValidation(){
        //Bootstrap validation
        (function() {
          'use strict';
          window.addEventListener('load', function() {
            var forms = document.getElementsByClassName('needs-validation');
            var validation = Array.prototype.filter.call(forms, function(form) {
              form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                  event.preventDefault();
                  event.stopPropagation();
                }
                form.classList.add('was-validated');
              }, false);
            });
          }, false);
        })();
        //Custom validate
        (function() {
            $('.form-block').submit(function(e){
                e.preventDefault();
                $('body').css({overflow: 'auto'}).addClass('no-off'); 
            });
            $('[submit]').on('click', function(){
               $('body').css({overflow: 'auto'}).addClass('no-off'); 
            });
        });
}
//Mobile header
function MobileHeader(){
            var header   = $('header');
            var partTop  = header.find('.header-top');
            var partMenu = header.find('.header-menu');
            var menu     = partMenu.find('.menu');
            if ( $(window).width() <= 1200 ) {
                resmenumob();                            
            }
            $(window).on('resize', function(){
                if (  $(window).width() <= 1200 ) {
                    resmenumob(); 
                } else {
                    resmenudes();
                };
            });
            
            function resmenumob(){
                menu.removeClass('flex-row align-items-center d-flex').addClass('flex-column align-items-start');
                partMenu.find('.container .row').append( partTop.find('.contact-info') );
                partMenu.find('.contact-info a:not(.offset-left)').removeClass('w-100 d-block');
                partMenu.find('.contact-info a.offset-left').removeClass('w-100');
                partMenu.find('.contact-info').removeClass('d-flex flex-column col-md-6 col-lg-3');
                if( header.hasClass('open') ){
                    partMenu.find('.contact-info').show();
                }
                else{
                    partMenu.find('.contact-info').hide();
                }
            }

            function resmenudes(){
                menu.addClass('flex-row align-items-center d-flex').removeClass('flex-column align-items-start');
                partTop.find('.container .row ').append( partMenu.find('.contact-info') );
                partTop.find('.contact-info a:not(.offset-left)').addClass('w-100 d-block');
                partMenu.find('.contact-info a.offset-left').addClass('w-100');
                partTop.find('.contact-info').addClass('d-flex flex-column col-md-6 col-lg-3').show();
            }

            partMenu.find('.burger').on('click', function(){ 
                    $(this).toggleClass('active');
                    header.toggleClass('open closed');
                    partMenu.toggleClass('open');
                    partMenu.find('.contact-info').toggle();
                    $('body').toggleClass('noscroll');
                    menu.toggle();
                    $('.overlay').toggleClass('mobile-on');
            });

            $(document).mouseup(function (e){ 
                if ( $(window).width() <= 1200 ) {
                    var div = $('header.open');
                    if (!div.is(e.target)&& div.has(e.target).length === 0) {
                        $('.burger').removeClass('active');
                        header.removeClass('open').addClass('closed');
                        partMenu.removeClass('open');
                        $('body').removeClass('noscroll');
                        menu.hide();
                        partMenu.find('.contact-info').hide();
                        $('.overlay').hide().removeClass('mobile-on');
                    }
                }
            });  
}
//Preloader
function Loader(){
            $(window).on('load', function () {
                    $preloader = $('.loaderArea'),
                    $loader = $preloader.find('.loader');
                    $loader.fadeOut();
                    $preloader.delay(450).fadeOut('slow');
                    //Modal form. Show & Hide
                    modalForms();
            });
}
//Modal forms
function modalForms(){
        $(document).ready(function(){
            $(this).on('click', '.popup-show', function(e){
                e.preventDefault();
                showForm();
            });
            if ( $(window).width() > 1200 ) {
                  setTimeout(showFormOut, 500);
            }
             //setTimeout(showForm, 1000);
             setInterval(showFormOut, 59000);
             setTimeout(showForm, 60000);
            //click out form close
            $('.popup-modal').on('click', function(e){
                    hideForm();  
            }).on('click', 'div', function(e) {
                e.stopPropagation();
            });
            //Esc button close
            $(this).keydown(function(eventObject){
                if (eventObject.which == 27){ 
                        hideForm();
                }
            });
            $('.modal').find('.close').on('click', function(){
                        hideForm();
            });
        });
}
//Modal form. Show
function showForm(){
            var header   = $('header');
            if( !is_404 && header.hasClass('closed') ){
                $(".l-popup").show(200);
                $('.l-popup').addClass('show');
                $('.overlay').show().addClass('on modal');
                $("body").addClass("modal-open");   
            }
}
function showFormOut(){
		$(document).on('mouseleave', function(e){
            var header   = $('header');
			if ( e.clientY < 0 && header.hasClass('closed') ) {
				showForm();
			}     
			$(this).off('mouseleave');
		});
}
//Modal form. Hide
function hideForm(){
            $(".l-popup").hide();
            $('.l-popup').removeClass('show');
            $('.overlay').removeClass('on modal').hide();
            $("body").removeClass("modal-open");
            $('form').removeClass('was-validated').find('input').val('');
}
//Sections and links
function Section_and_Anchor(){
    $(document).ready(function(){
        var section = $(document).find('section');
        section.eq(0).addClass('main-section');
        var counter = 1;
        section.each(function(){
            name = 'section-' + counter;
            $(this).attr('id', name );
            counter++;
            href = '#section-' + counter;
            $(this).find('.arrow-down').attr('href', href);
            var text = $(this).find('.text-part.long');
            var iconSrc = $(this).find('.custom-icon-body').text();
            if( window.iconSrc !== 'undefined' && iconSrc ){
                    text.find('li').prepend('<span class="custom-icon-image" style="margin-right: 10px;"><img src="' + iconSrc + '" height="25px" width="25px"></span>');
            }
        });
        section.on("click",".arrow-down", function (event) {
            event.preventDefault();
            var id  = $(this).attr('href'),
                top = $(id).offset().top;
            if( $(window).width() > 1024 ){
                var linkOffset = 60;
            }
            else{
                var linkOffset = 90;
            }
            $('body,html').animate({scrollTop: top - linkOffset }, 1500);
        }); 
    });
}
//Sticky header
function StickyHeader(){
        var nav = $('header');
        var mywindow = $(window);
        var mypos = mywindow.scrollTop();
        var up = false;
        var newscroll;
        if ( $(window).width() > 1200 ) {
            $(window).scroll(function () {
                newscroll = mywindow.scrollTop();
                if ($(this).scrollTop() > 100) {
                    nav.addClass("f-nav");
                    //nav.find('.header-top').fadeOut(100);
                }else{
                    nav.removeClass("f-nav");
                    //nav.find('.header-top').fadeIn(); 
                }
                mypos = newscroll;
            });
        }
}
//Phones accordion
function PhonesHeader(){
        $(document).ready(function(){
            if( $(window).width() > 1200 ){
                var contactInf = $('.contact-info, .footer-contact-block');
                contactInf.each(function(){
                    var tel = $(this).find('.offset-left');
                    if( tel.length > 0 ){
                        $(this).find('.tel-wrapper').addClass('has-child');
                    }
                });
               /* contactInf.hover( function(){
                    var tel = $(this).find('.offset-left');
                    if( tel.length > 0 ){
                        $(this).find('.offset-left').slideDown(300);
                        $(this).find('.tel-wrapper').removeClass('no-active').addClass('active');
                        $('header').find('.header-top').addClass('long-height');
                        $('header').find('.header-menu').addClass('long-height');
                    }
                });
                contactInf.mouseleave( function(){
                    var tel = $(this).find('.offset-left');
                    if( tel.length > 0 ){
                        $(this).find('.offset-left').slideUp(400);
                        $(this).find('.tel-wrapper').removeClass('active').addClass('no-active');
                        setTimeout( $('header').find('.header-top').removeClass('long-height'), 6000 );
                        setTimeout( $('header').find('.header-menu').removeClass('long-height'), 10000);
                    }
                });*/
            }
        });
}
//Custom validate tel
function validate(evt) {
      var theEvent = evt || window.event;
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode( key );
      var regex = /[0-9]|\./;
      if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
      }
}
//Image attr on hover
function ImgHover(){
        $(document).ready(function(){
           $('img').each(function(){
                var Title = $(this).attr('title');
                var Alt = $(this).attr('alt');
                $(this).on('hover', function(){
                   $(this).attr('alt', '');
                   $(this).attr('title', '');
                });
                $(this).on('mouseleave', function(){
                   $(this).attr('alt', Alt);
                   $(this).attr('title', Title);
                });
           });
        });
}
//Remove br tag
function remove_footer_BR(){
    $(document).ready(function(){
       $('.footer-contact-block').each(function(){
            var block = $(this);
            var space = ' ';
            var addr = block.find('p').html();
            var addr_mob = addr.replace('<br>', space);
            if ( $(window).width() <= 1000 ) {
                block.find('p').html(addr_mob);
            }
            $(window).on('resize', function(){
                if ( $(window).width() <= 1000 ) {
                    block.find('p').html(addr_mob);
                }
                else{
                    block.find('p').html(addr);
                }
            });
        }); 
    });
}
//FormRedirect
function FormRedirect() {
  var site_url = itk_ajax_params.site_url;
  var thank_page = '/thanks/';
  var redirect = site_url + thank_page;
  document.addEventListener('wpcf7mailsent', function (event) {
    location = redirect;
  },
    false
  );
}
/** Else **/
$(function(){
    width = $(window).width();
    height = $(window).height();
});
try{
    (function() {
     tinymce.create('tinymce-advanced.plugins.mark', {
     init : function(ed, url) {
     ed.addButton('mark', {
     title : 'Mark-выделение',
     image : 'bitton.png',
     onclick : function() {
     ed.selection.setContent('<mark>' + ed.selection.getContent() + '</mark>');
     }
     });
     },
     createControl : function(n, cm) {
     return null;
     },
     });
     tinymce.PluginManager.add('mark', tinymce.plugins.mayak);
    })();
}
catch{
    console.log('Script for ACF Custom Editor Button not working')
}